export const ClubSupportQuestions = [
  {
    title: "I can't log into the Mayfair Club App",
    answer: (
      <>
        Please make sure you are using the email address you used to complete
        your application form. If you are unsure of this email address, please
        contact{" "}
        <a href="mailto:membership@allbright.co">membership@allbright.co</a>
      </>
    ),
  },
  {
    title: "I can't log into my AllBright Digital account",
    answer: (
      <>
        After signing up as a Mayfair Club member, you will still need to create
        an account for our Digital platform{" "}
        <a href="https://www.allbrightcollective.com/digital/register">here</a>
      </>
    ),
  },
  // {
  //   title: "I can't download the app",
  //   answer: "Link to the App on an Android play store here. Link to the App store here.",
  // },
  {
    title: "I want to freeze my membership",
    answer: (
      <>
        We offer a limited time that you can freeze your membership if you are
        traveling or on maternity/adoption leave. Please email:{" "}
        <a href="mailto:membership@allbright.co">membership@allbright.co</a>
      </>
    ),
  },
  {
    title: "I want to cancel a ticket for an event and a refund",
    answer: (
      <>
        We only offer refunds to tickets purchased 24 hours prior to the event.
        Please email{" "}
        <a href="mailto:mayfairreservations@allbright.co">
          mayfairreservations@allbright.co
        </a>
      </>
    ),
  },
  {
    title: "I am a Club Member, and I can't buy a ticket to an event",
    answer: (
      <>
        Please email{" "}
        <a href="mailto:mayfairreservations@allbright.co">
          mayfairreservations@allbright.co
        </a>
      </>
    ),
  },
  {
    title: "I want to host an event with AllBright",
    answer: (
      <>
        Host an event form{" "}
        <a href="https://allbrightco.typeform.com/to/QlQgxbXN">here</a>
      </>
    ),
  },
  {
    title: "I want to refer a friend",
    answer: (
      <>
        Refer a friend form{" "}
        <a href="http://members.allbrightcollective.com/form/440">here</a>
      </>
    ),
  },
  {
    title: "I want to make a reservation",
    answer: (
      <>
        Reservation form:{" "}
        <a href="http://members.allbrightcollective.com/form/438">here</a>
      </>
    ),
  },
  {
    title: "I want to register a guest",
    answer: (
      <>
        Guest form:{" "}
        <a href="http://members.allbrightcollective.com/form/417">here</a>
      </>
    ),
  },
  {
    title: "I want to make a complaint",
    answer: (
      <>
        Complaint form:{" "}
        <a href="https://members.allbrightcollective.com/form/571?preview=yes">
          here
        </a>
      </>
    ),
  },
  {
    title: "I want to cancel my Club membership",
    answer: (
      <>
        Please use the form{" "}
        <a href="https://members.allbrightcollective.com/form/954">here</a>
      </>
    ),
  },
];

export const DigitalSupportQuestions = [
  // {
  //   title: "I can't find the Digital App on my phone",
  //   answer: "Please note that our Digital App is currently not available on android. Please follow this link – ADD LINK - WEBPAGE.",
  // },
  {
    title: "I can't log into my Digital account",
    answer: (
      <>
        If you are having issues logging in please contact us at{" "}
        <a href="mailto:digital@allbright.co">digital@allbright.co</a>. Please
        make sure to do this from the email address currently linked to your
        account.
      </>
    ),
  },
  {
    title: "I want to change my email address on my Digital account",
    answer: (
      <>
        To update your email address contact us at{" "}
        <a href="mailto:digital@allbright.co">digital@allbright.co</a>. Please
        make sure to do this from the email address currently linked to your
        account.
      </>
    ),
  },
  {
    title: "My iOS app looks different to the website",
    answer: (
      <>
        We are currently making great improvements to our Digital platform; for
        now please continue to use AllBright in your browser on desktop, tablet,
        or mobile while our native apps are updated in due course.
      </>
    ),
  },
  {
    title: "I am a Digital Member, and I can't buy a ticket to an event",
    answer: (
      <>
        Most of our events are available online, but some in-person events are
        only available to Mayfair Club members. Please check what type of event
        you are looking to attend.
      </>
    ),
  },
  {
    title: "I have a question about Mentor Matching",
    answer: (
      <>
        If you have any questions about our Mentor Matching feature please take
        a look at our Mentor Matching FAQs{" "}
        <a href="https://www.allbrightcollective.com/edit/articles/mentor-matching-everything-you-need-to-know">
          here
        </a>
        .
      </>
    ),
  },
  {
    title: "I want to cancel my Digital Membership",
    answer: (
      <>
        You can cancel your membership through your profile{" "}
        <a href="https://www.allbrightcollective.com/account?membership">
          here
        </a>
        , after which you will retain your membership until the end of the
        current billing period.
      </>
    ),
  },
];
